import { Directive } from '@angular/core';
import { ShowHideDirective } from '@angular/flex-layout';

const selector = `[fxShow.handset.landscape]`;
const inputs = ['fxShow.handset.landscape'];

@Directive({
  selector, 
  inputs
})
export class CustomFxShowHandsetLandscapeDirective extends ShowHideDirective {
  protected inputs = inputs;
}
